import { Controller } from "@hotwired/stimulus";

// Live password complexity checklist. All criteria must pass before the
// form can be submitted; the server enforces the same rules.
export default class extends Controller {
  static targets = ["input", "list", "criterion", "submit"];

  connect() {
    this.check();
  }

  check() {
    const { value } = this.inputTarget;

    if (this.hasListTarget) {
      this.listTarget.hidden = value.length === 0;
    }

    const passed = [
      value.length >= 12,
      /[\p{Lu}]/u.test(value),
      /[\p{Ll}]/u.test(value),
      /\d/.test(value),
      /[^A-Za-z0-9]/.test(value),
    ];

    this.criterionTargets.forEach((element, index) => {
      const ok = passed[index];
      element.classList.toggle("text-green-600", ok);
      element.classList.toggle("text-gray-500", !ok);
      const icon = element.querySelector("[data-strength-icon]");
      if (icon) {
        icon.textContent = ok ? "\u2713" : "\u25CB";
      }
      const status = element.querySelector("[data-strength-status]");
      if (status) {
        status.textContent = ok
          ? this.element.dataset.passwordStrengthMetText
          : this.element.dataset.passwordStrengthUnmetText;
      }
    });

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !passed.every(Boolean);
    }
  }
}
